import { Box, Button, Divider, Flex, Heading, Text, VStack } from '@chakra-ui/react'
import React from 'react'
import { Link } from 'react-router-dom'
import HeaderNavbar from '../../components/HeaderNavbar'
import SignupForm from '../../components/signupForm/SignupForm'

export default function Signup() {
    return (
        <Flex direction="column">
            <Flex flexBasis="48px">
                <HeaderNavbar />
            </Flex>
            <Flex flexGrow={1} alignItems="center" flexBasis="calc(100vh - 48px)" alignSelf="center" alignContent="center">
                <VStack>
                    <Box boxShadow="md" p={3} rounded="md" borderTop={1} borderColor={'blackAlpha.400'} >
                        <Heading as="h2" size="xl" textAlign="center">
                            Sign Up
                        </Heading>
                        <SignupForm />
                        <Divider my={4} colorScheme="teal" />
                        <Text textAlign="center" >Already joined ? 
                            <Button colorScheme="teal" mt={-1} ml={2} variant="link">
                                <Link to="/login">
                                    Log In
                                </Link>
                            </Button>
                        </Text>
                    </Box>
                </VStack>
            </Flex>
        </Flex>
    )
}
